import CryptoJS from "crypto-js";

const SECRET_KEY = "YOUR_SECRET_KEY_256_BIT"; //

// Encrypt text
export const encryptText = (text) => {
  return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
};

// Decrypt text
export const decryptText = (cipher) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipher, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return "";
  }
};
